<template>
  <div>
    <Breadcrumb msg1="商品库存" msg2="商品管理" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5"><el-input v-model="query.name" placeholder="商品名称" clearable></el-input></el-col>
        <el-col :span="5">
          <el-select v-model="query.category_id" placeholder="分类" clearable>
            <el-option v-for="c in categories" :key="c.id" :label="c.name" :value="c.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4"><el-input v-model="query.brand" placeholder="品牌" clearable></el-input></el-col>
        <el-col :span="4">
          <el-select v-model="query.is_frame" placeholder="是否镜架" clearable>
            <el-option label="镜架" :value="1"></el-option>
            <el-option label="非镜架" :value="0"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新增商品</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="编号" prop="productNo" width="110"></el-table-column>
        <el-table-column label="名称" prop="name" width="160"></el-table-column>
        <el-table-column label="分类" width="100"><template slot-scope="scope">{{ categoryName(scope.row.categoryId) }}</template></el-table-column>
        <el-table-column label="品牌" prop="brand" width="100"></el-table-column>
        <el-table-column label="规格" prop="spec" width="120"></el-table-column>
        <el-table-column label="零售价" prop="retailPrice" width="90"></el-table-column>
        <el-table-column label="成本价" prop="costPrice" width="90"></el-table-column>
        <el-table-column label="镜架" width="70">
          <template slot-scope="scope">{{ scope.row.isFrame === 1 ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '上架' : '下架' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" :type="scope.row.status === 1 ? 'warning' : 'success'" @click="toggleState(scope.row)">{{ scope.row.status === 1 ? '下架' : '上架' }}</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="640px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" v-if="show">
        <el-row>
          <el-col :span="12"><el-form-item label="商品编号"><el-input v-model="form.product_no" placeholder="留空自动生成"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="名称" required><el-input v-model="form.name"></el-input></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="分类">
              <el-select v-model="form.category_id" style="width: 100%">
                <el-option v-for="c in categories" :key="c.id" :label="c.name" :value="c.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"><el-form-item label="品牌"><el-input v-model="form.brand"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="规格"><el-input v-model="form.spec"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="单位"><el-input v-model="form.unit"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="条码"><el-input v-model="form.barcode"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="零售价"><el-input v-model.number="form.retail_price" type="number"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="成本价"><el-input v-model.number="form.cost_price" type="number"></el-input></el-form-item></el-col>
          <el-col :span="12">
            <el-form-item label="是否镜架">
              <el-switch v-model="form.is_frame" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-switch v-model="form.status" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="24"><el-form-item label="备注"><el-input v-model="form.remark" type="textarea"></el-input></el-form-item></el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, name: '', category_id: null, brand: '', is_frame: null, status: 1 },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: {},
      categories: []
    }
  },
  created () {
    this.getData()
    this.$axios.http.get('/categories').then(r => { if (r.data.status === 200) this.categories = r.data.data || [] })
  },
  methods: {
    categoryName (id) { const c = this.categories.find(x => x.id === id); return c ? c.name : '' },
    getData () {
      this.$axios.get('/products', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    add () {
      this.dialogTitle = '新增商品'
      this.form = { product_no: '', name: '', category_id: null, brand: '', unit: '', spec: '', barcode: '', retail_price: 0, cost_price: 0, is_frame: 0, status: 1, remark: '' }
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑商品'
      this.form = Object.assign({}, row, {
        product_no: row.productNo,
        category_id: row.categoryId,
        retail_price: row.retailPrice,
        cost_price: row.costPrice,
        is_frame: row.isFrame
      })
      this.show = true
    },
    save () {
      if (!this.form.name) { this.$message.warning('商品名称必填'); return }
      if (this.form.id) {
        this.$axios.put(`/products/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/products', () => { this.show = false; this.getData() }, this.form)
      }
    },
    del (id) {
      this.$axios.del(`/products/${id}`, () => this.getData())
    },
    toggleState (row) {
      const status = row.status === 1 ? 0 : 1
      this.$axios.put(`/products/${row.id}/state/${status}`, () => this.getData())
    }
  }
}
</script>
